import React, { Component } from 'react';
import BulletIncimingPayment from './BulletIncomingPayment.container';
import EmiIncimingPayment from './EmiIncomingPayment.container';
import Vreedhiui from './vreedhiIncomingPayments'
class IncomingContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            incomingPageToShow: 'bullet',
        }
    }

    render() {
        const { admin } = this.props
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12 recovery-tabs">
                        <div className="dashboard-tabs" style={{width:'100px'}}>
                        {/* <div className="dashboard-tabs" style={{width:'173px'}}> */}
                            <button className={this.state.incomingPageToShow == 'bullet' ? 'active' : ''} onClick={e => this.buttonActionHandler("bullet")}>Bullet</button>
                            <button className={this.state.incomingPageToShow == 'emi' ? 'active' : ''} onClick={e => this.buttonActionHandler("emi")}>Emi</button>
                            {/* <button className={this.state.incomingPageToShow == 'vreedhi' ? 'active' : ''} onClick={e => this.buttonActionHandler("vreedhi")}>vreedhi</button> */}

                        </div>
                    </div>
                </div>
                {this.state.incomingPageToShow == 'bullet' ?
                    <BulletIncimingPayment
                        admin={admin} />
                    : this.state.incomingPageToShow == 'emi' ?
                        <EmiIncimingPayment
                            admin={admin} />
                            : this.state.incomingPageToShow == 'vreedhi' ?
                            <Vreedhiui
                                admin={admin} />
                        : null}
            </div>
        )
    }

    buttonActionHandler(type) {
        this.setState({
            incomingPageToShow: type
        })
    }

}


export default IncomingContainer;